var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.02 8.113a.7.7 0 0 1-.049.989l-7.167 6.5a.7.7 0 0 1-.942-.002L6.03 12.1a.7.7 0 1 1 .944-1.034l3.363 3.07 6.695-6.071a.7.7 0 0 1 .988.048",
  clipRule: "evenodd"
})));
export default SvgCheck;